class UpdateDetailsResponse {
    constructor(user_Id, userNum, created_For, first_Name, last_Name, age, height, weight, marital_StatusId, marital_Status,
        body_Type, disability_id, disability, mother_TongueId, mother_Tongue, eating_HabitId, eating_Habit, smoking_HabitId, smoking_Habit, drinking_HabitId, drinking_Habit, email,
        religion, caste, subCaste, gothram, date_Of_Birth, time_of_Birth, place_of_Birth,
        password, created_By, modified_By, modified_on, family_Value, family_Type, family_Status, father_Occupation, mother_Occupation, noOfBrothers,
        brothersMarried, brothers_Married, noOfSisters, sistersMarried, education_CategoryId, education_in_Detail, institution, occupationId, occupation, highesteducation, employed_InId, employed_In, work_Location, from_Income, to_Income,

        district_Id, district, stateCode, state_Id, state, country_Id, country, city, citizenship, ancestral_Origin, pincode, line_1, line_2, contact, isEmail, isPhone, phone, mobile_Number, isPaidUser, isPaid, lookUpId, living_Preference_Id, living_Preference
        ,themeColour,themeColourText,themeColourNumber

    ) {


        this.user_Id = user_Id;
        this.userNum = userNum;
        this.created_For = created_For;
        this.first_Name = first_Name;
        this.last_Name = last_Name;
        this.age = age;


        this.height = height;
        this.weight = weight;
        this.marital_StatusId = marital_StatusId;
        this.marital_Status = marital_Status;
        this.body_Type = body_Type;
        this.disability_id = disability_id;
        this.disability = disability;
        this.mother_TongueId = mother_TongueId;
        this.mother_Tongue = mother_Tongue;
        this.eating_HabitId = eating_HabitId;
        this.eating_Habit = eating_Habit;
        this.smoking_HabitId = smoking_HabitId;
        this.smoking_Habit = smoking_Habit;
        this.drinking_HabitId = drinking_HabitId;
        this.drinking_Habit = drinking_Habit;

        // this.gender = gender;
        this.email = email;
        this.caste = caste;

        this.religion = religion;
        this.subCaste = subCaste;
        this.gothram = gothram;
        this.date_Of_Birth = date_Of_Birth;
        this.time_of_Birth = time_of_Birth;
        this.place_of_Birth = place_of_Birth;
        // this.password = password;
        // this.created_By = created_By;
        // this.modified_By = modified_By;
        // this.modified_on = modified_on;
        this.highesteducation = highesteducation;
        this.education_CategoryId = education_CategoryId;
        this.education_in_Detail = education_in_Detail;
        this.institution = institution;
        this.occupationId = occupationId;
        this.occupation = occupation;
        // this.organization = organization;
        this.employed_InId = employed_InId;
        this.employed_In = employed_In;
        // this.work_Location = work_Location;
        // this.from_Income = from_Income;
        // this.to_Income = to_Income;



        this.family_Value = family_Value;
        this.family_Type = family_Type;
        this.family_Status = family_Status;
        this.father_Occupation = father_Occupation;
        this.mother_Occupation = mother_Occupation;
        this.noOfBrothers = noOfBrothers;
        this.brothersMarried = brothersMarried;
        this.brothers_Married = brothers_Married;
        this.noOfSisters = noOfSisters;
        this.sistersMarried = sistersMarried;
        this.district_Id = district_Id;
        this.district = district;
        this.stateCode = stateCode;
        this.state_Id = state_Id;
        this.state = state;
        this.country_Id = country_Id;
        this.country = country;
        this.city = city;
        this.citizenship = citizenship;
        this.ancestral_Origin = ancestral_Origin;
        this.pincode = pincode;
        this.line_1 = line_1;
        this.line_2 = line_2;
        this.contact = contact;
        this.isEmail = isEmail;
        this.isPhone = isPhone;
        this.phone = phone;
        this.mobile_Number = mobile_Number;
        this.isPaidUser = isPaidUser;
        this.isPaid = isPaid;
        this.lookUpId = lookUpId;
        this.living_Preference_Id = living_Preference_Id;
        this.living_Preference = living_Preference;
        this.themeColour = themeColour;
        this.themeColourText = themeColourText;
        this.themeColourNumber = themeColourNumber;








    }
    static fromJson(json) {
        return new UpdateDetailsResponse(
            json.user_Id,
            json.userNum,
            json.created_For,
            json.first_Name,
            json.last_Name,
            json.age,

            json.height,
            json.weight,
            json.marital_StatusId,
            json.marital_Status,
            json.body_Type,
            json.disability_id,
            json.disability,
            json.mother_TongueId,

            json.mother_Tongue,
            json.eating_HabitId,
            json.eating_Habit,
            json.smoking_HabitId,
            json.smoking_Habit,
            json.drinking_HabitId,
            json.drinking_Habit,

            // json.gender,
            json.email,
            // 
            // json.phone,
            json.caste,
            json.religion,
            json.subCaste,
            json.gothram,
            json.date_Of_Birth,
            json.time_of_Birth,
            json.place_of_Birth,
            // json.password,
            // json.created_By,
            // json.modified_By,
            // json.modified_on,

            json.family_Value,
            json.family_Type,
            json.family_Status,
            json.father_Occupation,
            json.mother_Occupation,
            json.noOfBrothers,
            json.brothersMarried,
            json.brothers_Married,
            json.noOfSisters,
            json.sistersMarried,
            json.education_CategoryId,
            json.education_in_Detail,
            json.institution,
            json.occupationId,
            json.occupation,
            json.highesteducation,
            json.employed_InId,
            json.employed_In,
            // json.work_Location,
            // json.from_Income,
            // json.to_Income,

            json.district_Id,
            json.district,
            json.stateCode,
            json.state_Id,
            json.state,
            json.country_Id,
            json.country,
            json.city,
            json.citizenship,
            json.ancestral_Origin,
            json.pincode,
            json.line_1,
            json.line_2,
            json.contact,
            json.isEmail,
            json.isPhone,
            json.phone,
            json.mobile_Number,
            json.isPaidUser,
            json.isPaid,
            json.lookUpId,
            json.living_Preference_Id,
            json.living_Preference,
            json.themeColour ,
            json.themeColourText,
            json.themeColourNumber




        );
    }
}

export default UpdateDetailsResponse;